import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Signup from "../components/User/signup/signup";

export default withRouter(connect()(Signup));
